// extracted by mini-css-extract-plugin
module.exports = {"container":"_2qEs1IPihSYK2C3vr8_-D6","strong_shadow":"_2VPz0Y2Mzbq3kVL8JgZRDh"};